import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope, faUser, faIdBadge } from '@fortawesome/free-regular-svg-icons'
import { formatCurrency } from '../utils/currencyUtils';

function Referrals({selectedUser}) {
    const [refUser, setRefUser] = useState(0);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ fetchReferral1: true, referralID : selectedUser.referralID  })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
                setRefUser(data.ref);
            }
        })
        .catch(err => {
        })
    }, [selectedUser]);
    return (
        <div>
            <p className="fw-bold mb-0">Actions</p>
            <p className="mb-0" style={{fontSize:'14px'}}>Perform actions on user account</p>
            <div className="mt-3 rounded-4 p-1" style={{backgroundColor:'rgba(255,255,255,0.03)',cursor:'pointer'}}>
                <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                    <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.fullname}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover lh-1 rounded-3">
                    <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faIdBadge} style={{fontSize: '16px'}} className="me-1" /> @{selectedUser.username}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                    <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faEnvelope} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.email}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                    <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faPhone} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.phone}</p>
                </div>
            </div>
            <p className="fw-bold mb-0 mt-4">Balance</p>
            <p className="mb-3" style={{fontSize:'14px'}}>User's referral balance</p>
            <div className="rounded-4 p-4 mb-2" style={{backgroundColor: '#1a1c1f'}}>
                <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Referral Balance</p>
                <h5 className="mb-0 fw-bold text-white">${formatCurrency(selectedUser.bonus)}</h5>
            </div>
            <p className="fw-bold mb-0 mt-4">Referrals</p>
            <p className="mb-3" style={{fontSize:'14px'}}>User's referral statistics and referrals</p>
            <p className="mb-0 mb-3 mt-4" style={{fontSize:'12px'}}>Statistics</p>
            <div className='d-flex align-items-center' style={{gap:'20px'}}>
                <div>
                    <p className="mb-0" style={{fontSize:'13px'}}>Friends invited</p>
                    <p className="mb-0 fs-4 fw-bold">{refUser}</p>
                </div>
                <div>
                    <p className="mb-0" style={{fontSize:'13px'}}>Rewards claimed</p>
                    <p className="mb-0 fs-4 fw-bold">${formatCurrency(selectedUser.claimed_reward)}</p>
                </div>
            </div>
        </div>
    )
}
 
export default Referrals